import React, {useContext} from 'react';

import {CommentsSortByReaction} from '@components/molecules/comments/sortbyreaction';

import {pushRoute} from '~/src/utilities/helpers/router';
import {ReactionContext} from '~/src/components/context/ReactionContext';
import {SitemapContext} from '~/src/components/context/SitemapContext';
import {getPageUrl} from '~/src/utilities/helpers/link';
import initPolyglot from '~/src/utilities/libs/polyglot';

import i18n from './CommentReactionSort.i18n.json';

const translate = initPolyglot(i18n);

interface CommentReactionSortProps {
    contentId: number;
    sortBy: string;
}

const CommentReactionSort: React.FC<CommentReactionSortProps> = ({contentId, sortBy}) => {
    const allReactions = {key: 'all', label: translate('all'), colors: {light: '', dark: ''}};
    const reactions = useContext(ReactionContext);
    const {all} = useContext(SitemapContext);

    let [, sortByKey] = sortBy.split('-');

    if (!sortByKey && sortBy === 'reactions') {
        sortByKey = 'all';
    }

    return (
        <CommentsSortByReaction
            items={[allReactions, ...reactions]}
            activeKey={sortByKey}
            onChange={(key) => {
                if (key === 'all') {
                    pushRoute(all, getPageUrl(`/comment/${contentId}/reactions`));
                } else {
                    pushRoute(all, getPageUrl(`/comment/${contentId}/reactions-${key}`));
                }
            }}
        />
    );
};

export default CommentReactionSort;
